import { Grid, Box } from "@mantine/core";
import { useContext, useEffect, useCallback } from "react";
import { AppContext } from "src/api/AppContext";
import { ROUTE_NAMES, defaultPagination } from "src/utils/constants";
import Revenue from "./Revenue";
import PointOfSale from "./PointOfSale";
import Agreements from "./Agreements";
import Packages from "./Packages";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import DashboardCard from "./DashboardCard";
import MultiSelect from "src/components/MultiSelect";
import Dues from "./Dues";
import { useDashboardContext } from "src/api/context/DashboardContext";

// used for react-chart-2
ChartJS.register(ArcElement, Tooltip, Legend);

export default function Dashboard() {
  const {
    filters,
    setFilters,
    getDateRangeText,
    handleModal,
    handleLocChange,
    setPaginationParams,
    filtersQuick,
    setFiltersQuick,
  } = useDashboardContext();
  const { setCurrentPageTitle, currentOrganization } = useContext(AppContext);

  useEffect(() => {
    setCurrentPageTitle(ROUTE_NAMES.DASHBOARD);
    setPaginationParams(defaultPagination);
    return () => {
      setCurrentPageTitle(undefined);
    };
  }, []);

  const renderWidgets = useCallback(() => {
    return (
      <Grid gutter="sm" p={12} m={0}>
        <Grid.Col md={6} xs={12}>
          <Revenue filters={filters} />
        </Grid.Col>
        <Grid.Col md={6} xs={12}>
          <PointOfSale filters={filters} />
        </Grid.Col>
        <Grid.Col md={6} xs={12}>
          <Agreements filters={filters} />
        </Grid.Col>
        <Grid.Col md={6} xs={12}>
          <Packages filters={filters} />
        </Grid.Col>
      </Grid>
    );
  }, [filters]);

  const renderWidgetsQuickSelect = useCallback(() => {
    return (
      <Box p={12}>
        <Dues filters={filtersQuick} />
      </Box>
    );
  }, [filtersQuick]);

  return (
    <>
      <Box sx={{ maxWidth: 500 }} mb={"xs"}>
        <MultiSelect
          placeholder="Locations"
          data={
            currentOrganization?.locations?.map((loc) => ({
              value: loc.id,
              label: loc.name,
            })) || []
          }
          searchable
          nothingFound="No Location Found"
          onChange={handleLocChange}
          value={filters.locations}
          style={{
            borderRadius: "20px !important",
          }}
          // sx={{
          //   ".mantine-Input-input": {
          //     borderRadius: 30,
          //   },
          //   ".mantine-MultiSelect-values": {
          //     input: { lineHeight: "inherit" },
          //   },
          // }}
        />
      </Box>
      <DashboardCard
        filters={filters}
        setFilters={setFilters}
        getDateRangeText={() => getDateRangeText(filters)}
        handleModal={() => handleModal(false)}
        rightIconButton={<></>}
      >
        <Box>{renderWidgets()}</Box>
      </DashboardCard>
      <br />
      <DashboardCard
        filters={filtersQuick}
        setFilters={setFiltersQuick}
        getDateRangeText={() => getDateRangeText(filtersQuick)}
        handleModal={() => handleModal(true)}
        rightIconButton={<></>}
        showQuickSelectOption={true}
      >
        <Box>{renderWidgetsQuickSelect()}</Box>
      </DashboardCard>
    </>
  );
}
